// extracted by mini-css-extract-plugin
export var orderDetails = "_qe-2";
export var orderImage = "_qe-1";
export var orderMeta = "_qe-3";
export var orderSummary = "_qe-0";
export var rightArrow = "_qe-4";